/**
 * @hidden
 */
export var packageMetadata = {
  name: '@progress/kendo-react-pdf',
  productName: 'KendoReact',
  productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
  publishDate: 1603297284,
  version: '',
  licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/'
};